export default {
  integrations: [],
  status: {},
};